import {Fragment} from 'react';
import PropTypes from 'prop-types';
import {Table} from 'semantic-ui-react';
import {BLANK_TEXT} from '../../utils';
import {formatDatetime} from '../../utils/datetime';

function StudentCourses(props) {
  const {studentCourses} = props;
  return (
    <Table striped unstackable color='green' size='small'>
      <Table.Header>
        <Table.Row textAlign='center'>
          <Table.HeaderCell colSpan={5} textAlign='center' content='لیست کورس ها'/>
        </Table.Row>
        <Table.Row textAlign='center'>
          <Table.HeaderCell content='نام'/>
          <Table.HeaderCell content='وضعیت'/>
          <Table.HeaderCell content='زمان شروع'/>
          <Table.HeaderCell content='زمان انجام'/>
          <Table.HeaderCell content='درصد انجام شده'/>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {studentCourses.map(studentCourse => (
          <Fragment key={studentCourse.id}>
            <Table.Row className={`${statusColor[studentCourse.status]}-text`}>
              <Table.Cell textAlign='center' content={studentCourse.name}/>
              <Table.Cell textAlign='center' content={statusList[studentCourse.status]}/>
              <Table.Cell
                textAlign='center'
                content={studentCourse.started ?
                  formatDatetime(studentCourse.started, 'jMM/jDD') :
                  BLANK_TEXT
                }
              />
              <Table.Cell
                textAlign='center'
                content={(studentCourse.duration !== null) ? `${studentCourse.duration} روز` : BLANK_TEXT}
              />
              <Table.Cell
                textAlign='center'
                content={(studentCourse.status !== 0) ? `%${studentCourse.donePercent}` : BLANK_TEXT}
              />
            </Table.Row>
          </Fragment>
        ))}
      </Table.Body>
    </Table>
  );
}

const statusList = ['ایجاد شده', 'شروع شده', 'بسته شده', 'تمام شده'];
const statusColor = ['black', 'blue', 'red', 'green'];

StudentCourses.propTypes = {
  studentCourses: PropTypes.array.isRequired
};

export default StudentCourses;
